import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetonagpurcab() {



    const cardData = {

keyword: "Pune to Nagpur Cab",

headingDescription:
    "Rising Cab Service offers safe and comfortable Pune to Nagpur Cab services for families, business travelers, tourists, and long-distance passengers. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles driven by experienced chauffeurs for a smooth highway journey. Our service includes one-way and round-trip options, doorstep pickup from Pune, 24/7 booking support, and transparent pricing. Whether for business travel, family visits, or tourism, Rising Cab Service ensures a reliable and hassle-free journey from Pune to Nagpur.",

topPlaces: [
    {
        title: "Deekshabhoomi",
        description:
            "Deekshabhoomi is a major Buddhist monument in Nagpur where Dr. B.R. Ambedkar embraced Buddhism. It is one of the most important pilgrimage sites in India for followers of Buddhism."
    },
    {
        title: "Futala Lake",
        description:
            "Futala Lake is a popular scenic spot in Nagpur known for its beautiful sunset views, musical fountains, and vibrant evening atmosphere, attracting tourists and locals alike."
    },
    {
        title: "Ambazari Lake and Garden",
        description:
            "Ambazari Lake is one of the largest lakes in Nagpur, surrounded by a well-maintained garden. It is a peaceful picnic spot ideal for families and nature lovers."
    },
    {
        title: "Sitabuldi Fort",
        description:
            "Sitabuldi Fort is a historic fort located in the heart of Nagpur, known for its role in the Anglo-Maratha war and offering panoramic views of the city."
    },
    {
        title: "Maharaj Bagh Zoo",
        description:
            "Maharaj Bagh Zoo is a well-known zoological garden in Nagpur featuring various animal species and lush greenery, making it a family-friendly attraction."
    },
    {
        title: "Swaminarayan Temple Nagpur",
        description:
            "The Swaminarayan Temple in Nagpur is a beautifully built spiritual center known for its peaceful atmosphere, architecture, and devotional activities."
    },
    {
        title: "Dragon Palace Temple",
        description:
            "Dragon Palace Temple is a stunning Buddhist temple located in Kamptee near Nagpur, known for its serene environment and Japanese-inspired architecture."
    },
    {
        title: "Ramtek Temple",
        description:
            "Ramtek Temple is a famous hilltop temple dedicated to Lord Rama, believed to be the place where Lord Rama rested during his exile."
    },
    {
        title: "Zero Mile Stone",
        description:
            "Zero Mile Stone marks the geographical center of colonial India and is a historic monument in Nagpur symbolizing distance measurements."
    },
    {
        title: "Khindsi Lake",
        description:
            "Khindsi Lake is a popular weekend destination near Nagpur offering boating, water sports, and scenic natural surroundings."
    }
],



services: [
    {
        name: "Pune to Nagpur Cab",
        description:
            "Rising Cab Service offers Pune to Nagpur Cab services for safe, comfortable, and reliable long-distance travel across Maharashtra. Our intercity cab service is ideal for business trips, family travel, corporate tours, relocations, and holiday journeys. We provide well-maintained AC vehicles, experienced highway drivers, door-to-door pickup and drop, and transparent pricing with no hidden charges. Customers can choose from sedan, SUV, Innova, and Innova Crysta options based on comfort and group size. With flexible one-way and round-trip options, 24x7 availability, and instant booking support, we ensure a smooth and stress-free travel experience between Pune and Nagpur."

    },
    {
        name: "Pune to Nagpur Taxi",
        description:
            "Book Pune to Nagpur Taxi with Rising Cab Service for dependable and affordable intercity transportation. Our taxis are suitable for solo travelers, families, and corporate passengers looking for safe and comfortable long-distance travel with professional drivers and clean vehicles."
    },
    {
        name: "Cab from Pune to Nagpur",
        description:
            "Rising Cab Service provides Cab from Pune to Nagpur with flexible travel options including one-way drops and round-trip journeys. Enjoy comfortable seating, smooth highway rides, and reliable service throughout the journey."
    },
    {
        name: "Taxi from Pune to Nagpur",
        description:
            "Our Taxi from Pune to Nagpur service ensures safe, timely, and comfortable transportation with experienced chauffeurs and well-maintained vehicles for long-distance travel."
    },
    {
        name: "Pune to Nagpur Cab Service",
        description:
            "Rising Cab Service offers Pune to Nagpur Cab Service with professional drivers, AC vehicles, and flexible booking options for business, family, and tourism travel needs."
    },
    {
        name: "Pune to Nagpur Taxi Fare",
        description:
            "Get affordable Pune to Nagpur Taxi Fare with transparent pricing, no hidden charges, and economical travel options designed for long-distance journeys."
    },
    {
        name: "Pune to Nagpur One Way Cab",
        description:
            "Book Pune to Nagpur One Way Cab for budget-friendly single-direction travel with professional drivers and comfortable vehicles, ideal for relocation and business trips."
    },
    {
        name: "Pune to Nagpur Round Trip Taxi",
        description:
            "Rising Cab Service provides Pune to Nagpur Round Trip Taxi with flexible return schedules, waiting options, and customized travel plans for families and corporate groups."
    },
    {
        name: "Pune to Nagpur Cab Booking",
        description:
            "Our Pune to Nagpur Cab Booking service allows instant and advance reservations with multiple vehicle options and 24x7 customer support for smooth travel planning."
    },
    {
        name: "Cheap Pune to Nagpur Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Nagpur Cab with economical pricing while maintaining safety, comfort, and reliable service for long-distance journeys."
    },
    {
        name: "Best Pune to Nagpur Taxi",
        description:
            "Choose the Best Pune to Nagpur Taxi with Rising Cab Service for premium comfort, professional chauffeurs, and dependable intercity travel solutions."
    },
    {
        name: "Sedan Pune to Nagpur Cab",
        description:
            "Our Sedan Pune to Nagpur Cab service offers comfortable and budget-friendly travel for individuals and small families with clean and well-maintained vehicles."
    },
    {
        name: "SUV Pune to Nagpur Taxi",
        description:
            "Book SUV Pune to Nagpur Taxi for spacious seating and extra luggage capacity, ideal for family trips and group travel over long distances."
    },
    {
        name: "Innova Pune to Nagpur Cab",
        description:
            "Rising Cab Service provides Innova Pune to Nagpur Cab for comfortable family and group travel with spacious interiors and smooth highway rides."
    },
    {
        name: "Long Distance Cab Pune Nagpur",
        description:
            "Our Long Distance Cab Pune Nagpur service ensures safe and reliable intercity travel with experienced drivers, AC vehicles, and flexible travel options for extended journeys."
    },
    {
        name: "Pune to Nagpur Cabs",
        description:
            "Rising Cab Service offers Pune to Nagpur Cabs with one-way, round-trip, and customized travel solutions for all types of passengers."
    },
    {
        name: "Pune to Nagpur Cab Service",
        description:
            "Our Pune to Nagpur Cab Service provides reliable and comfortable transportation with professional chauffeurs and affordable pricing."
    },
    {
        name: "Pune to Nagpur Taxi Service",
        description:
            "Book Pune to Nagpur Taxi Service for safe and convenient long-distance travel with door-to-door pickup and drop facilities."
    },
    {
        name: "Pune to Nagpur Cab Booking",
        description:
            "Rising Cab Service offers Pune to Nagpur Cab Booking with instant confirmation and flexible scheduling for all travel needs."
    },
    {
        name: "Best Pune to Nagpur Cab",
        description:
            "Choose the Best Pune to Nagpur Cab for premium travel experience, reliable service, and comfortable long-distance journeys."
    },
    {
        name: "One Way Pune to Nagpur Cab",
        description:
            "Book One Way Pune to Nagpur Cab for affordable single-trip travel with experienced drivers and comfortable vehicles."
    },
    {
        name: "Round Trip Pune to Nagpur Taxi",
        description:
            "Our Round Trip Pune to Nagpur Taxi service provides flexible travel planning with return journey options and customized packages."
    },
    {
        name: "Cheap Pune to Nagpur Cab",
        description:
            "Rising Cab Service offers Cheap Pune to Nagpur Cab with budget-friendly fares and safe, comfortable long-distance transportation."
    },
    {
        name: "24x7 Pune to Nagpur Cab Service",
        description:
            "Book 24x7 Pune to Nagpur Cab Service with Rising Cab Service for round-the-clock availability and reliable intercity travel."
    },
    {
        name: "Outstation Cab Pune to Nagpur",
        description:
            "Our Outstation Cab Pune to Nagpur service provides safe, comfortable, and affordable long-distance travel for all passenger types."
    },
    {
        name: "Pune to Nagpur Innova Cab",
        description:
            "Rising Cab Service offers Pune to Nagpur Innova Cab for spacious, comfortable, and premium group travel with experienced chauffeurs."
    },
    {
        name: "Pune to Amravati Cab Service",
        description:
            "Book Pune to Amravati Cab Service for safe and reliable intercity travel with comfortable AC vehicles and professional drivers."
    },
    {
        name: "Pune to Amravati Taxi",
        description:
            "Our Pune to Amravati Taxi service ensures smooth highway travel with affordable pricing and experienced chauffeurs."
    },
    {
        name: "Pune to Amravati Innova Crysta",
        description:
            "Rising Cab Service provides Pune to Amravati Innova Crysta for premium comfort, family trips, and long-distance journeys."
    },
    {
        name: "Pune to Amravati Tempo Traveller",
        description:
            "Book Pune to Amravati Tempo Traveller for large group travel with spacious seating and comfortable long-distance transport."
    },
    {
        name: "Pune to Amravati One Way Cab",
        description:
            "Our Pune to Amravati One Way Cab service offers economical single-trip travel with reliable drivers and comfortable vehicles."
    },
    {
        name: "Pune to Akola Cab Service",
        description:
            "Rising Cab Service provides Pune to Akola Cab Service for safe and affordable intercity travel with flexible booking options."
    },
    {
        name: "Pune to Akola Taxi Booking",
        description:
            "Book Pune to Akola Taxi Booking with instant confirmation and comfortable long-distance travel solutions."
    },
    {
        name: "Pune to Akola SUV Cab",
        description:
            "Our Pune to Akola SUV Cab service offers spacious and comfortable travel for families and group passengers."
    },
    {
        name: "Pune to Akola Round Trip Cab",
        description:
            "Rising Cab Service provides Pune to Akola Round Trip Cab with flexible return timing and comfortable intercity travel options."
    },
    {
        name: "Pune to Bhandara Cab Service",
        description:
            "Book Pune to Bhandara Cab Service for reliable and safe long-distance travel with professional chauffeurs."
    },
    {
        name: "Pune to Bhandara Taxi",
        description:
            "Our Pune to Bhandara Taxi service offers comfortable and affordable intercity travel with clean AC vehicles."
    },
    {
        name: "Pune to Bhandara Innova Cab",
        description:
            "Rising Cab Service provides Pune to Bhandara Innova Cab for spacious, premium, and comfortable long-distance journeys."
    }
],

tableData: [
    ["Pune to Nagpur Cab", "Pune to Nagpur Taxi"],
    ["Cab from Pune to Nagpur", "Taxi from Pune to Nagpur"],
    ["Pune to Nagpur Cab Service", "Pune to Nagpur Taxi Fare"],
    ["Pune to Nagpur One Way Cab", "Pune to Nagpur Round Trip Taxi"],
    ["Cheap Pune to Nagpur Cab", "Best Pune to Nagpur Taxi"],
    ["Sedan Pune to Nagpur Cab", "SUV Pune to Nagpur Taxi"],
    ["Innova Pune to Nagpur Cab", "Long Distance Cab Pune Nagpur"],
    ["Pune to Nagpur Cabs", "Pune to Nagpur Cab Service"],
    ["Pune to Nagpur Taxi Service", "Pune to Nagpur Cab Booking"],
    ["Best Pune to Nagpur Cab", "One Way Pune to Nagpur Cab"],
    ["Round Trip Pune to Nagpur Taxi", "Cheap Pune to Nagpur Cab"],
    ["24x7 Pune to Nagpur Cab Service", "Outstation Cab Pune to Nagpur"],
    ["Pune to Nagpur Innova Cab", "Pune to Amravati Cab Service"],
    ["Pune to Amravati Taxi", "Pune to Amravati Innova Crysta"],
    ["Pune to Akola Cab Service", "Pune to Akola Taxi Booking"],
    ["Pune to Akola SUV Cab", "Pune to Akola Round Trip Cab"],
    ["Pune to Bhandara Cab Service", "Pune to Bhandara Taxi"],
    ["Pune to Bhandara Innova Cab", "Pune to Nagpur Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Nagpur Cab Service",
        WhyChoosedescription: "Rising Cab Service provides comfortable Pune to Nagpur cab travel for business professionals, families, students, tourists, and long-distance travelers."
    },
    {
        WhyChooseheading: "Convenient Travel Across Maharashtra",
        WhyChoosedescription: "Enjoy seamless road travel between Pune and Nagpur with flexible schedules, professional drivers, and comfortable vehicles suitable for extended journeys."
    },
    {
        WhyChooseheading: "Suitable for Business and Personal Trips",
        WhyChoosedescription: "Whether you're traveling for corporate meetings, family functions, educational purposes, medical visits, or vacations, we offer travel solutions for every requirement."
    },
    {
        WhyChooseheading: "Vehicle Options for Every Group Size",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on passenger count and travel preferences."
    },
    {
        WhyChooseheading: "Flexible One-Way and Return Travel",
        WhyChoosedescription: "We provide one-way cab services, round-trip bookings, multi-day travel packages, and customized itineraries according to customer needs."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Pickup services are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and all major Pune locations."
    },
    {
        WhyChooseheading: "Long-Distance Travel with Comfort",
        WhyChoosedescription: "Our well-maintained vehicles and experienced drivers ensure a relaxed and safe journey throughout the Pune to Nagpur route."
    },
    {
        WhyChooseheading: "Customized Stops During Travel",
        WhyChoosedescription: "Passengers can include meal breaks, sightseeing locations, business stops, and overnight halts as per their travel plans."
    }
]
};

const faqData = [
    {
        question: "Why do travelers choose road travel from Pune to Nagpur?",
        answer: "Many travelers prefer road journeys for flexibility, comfort, personalized schedules, and convenient door-to-door transportation."
    },
    {
        question: "Can customers book a one-way cab from Pune to Nagpur?",
        answer: "Yes, one-way cab services are available along with return-trip and multi-day travel options."
    },
    {
        question: "Which vehicles are commonly booked for the Pune to Nagpur route?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices depending on group size and comfort requirements."
    },
    {
        question: "Are corporate travel bookings available for Nagpur?",
        answer: "Yes, business professionals frequently use our cab services for meetings, conferences, industrial visits, and official travel."
    },
    {
        question: "Can families travel comfortably on this long-distance route?",
        answer: "Yes, spacious vehicles with comfortable seating make the journey suitable for families, children, and senior citizens."
    },
    {
        question: "Is it possible to include stops during the journey?",
        answer: "Yes, travelers can request rest stops, dining breaks, sightseeing visits, or overnight halts according to their itinerary."
    },
    {
        question: "Do you provide multi-day cab packages for Nagpur travel?",
        answer: "Yes, customers can book vehicles for extended travel durations, return trips, and customized tour plans."
    },
    {
        question: "Can pickups be arranged from Pune Airport or Railway Station?",
        answer: "Yes, travelers can begin their journey from Pune Airport, Railway Station, hotels, offices, or residential locations."
    },
    {
        question: "Is advance booking recommended for Pune to Nagpur cabs?",
        answer: "Yes, advance reservation helps secure preferred vehicle options and ensures smoother travel planning."
    },
    {
        question: "How can I reserve a Pune to Nagpur Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Prashant Wankhede",
        feedback:
            "Traveling from Pune to Nagpur for a family event was extremely comfortable. The vehicle condition was excellent, and the journey was managed efficiently throughout the route.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Bhagyashree Kale",
        feedback:
            "Our long-distance trip to Nagpur was smooth and well-organized. The driver maintained a professional approach, and the travel experience remained comfortable from start to finish.",
        rating: 5
    }
];





    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];












const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Nagpur Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-nagpur-cab.jpg",
"description": "Book Pune to Nagpur Cab Service with Rising Cab Service for safe and comfortable long-distance travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova options for family and business trips.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-nagpur-cab"
}
};






    return (
        <div>

<Helmet>
  <title>Pune to Nagpur Cab Service | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Nagpur Cab Service for safe, reliable, and comfortable long-distance travel. Get affordable one-way and round-trip taxi service with sedan, SUV, and Innova cars."
/>

<meta
 name="keywords"
 content="Pune to nagpur cab, pune to nagpur taxi, cab from pune to nagpur, taxi from pune to nagpur, pune to nagpur cab service, pune to nagpur taxi fare, pune to nagpur one way cab, pune to nagpur round trip taxi, pune to nagpur cab booking, cheap pune to nagpur cab, best pune to nagpur taxi, sedan pune to nagpur cab, suv pune to nagpur taxi, innova pune to nagpur cab, long distance cab pune nagpur, Pune to Nagpur Cab Service, Pune to Nagpur Taxi Service, Pune to Nagpur Cab Booking"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>


            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/36.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetonagpurcab;